"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummyRef = void 0;
class DummyRef {
}
exports.DummyRef = DummyRef;
//# sourceMappingURL=ref.js.map